module.exports = __webpack_public_path__ + "static/media/ticket.svg";